const Account = () => import('@/views/Account');
const Activities = () => import('@/views/childrens/management/Activities');
const Assistance = () => import('@/views/childrens/management/Assistance');
const Audit = () => import('@/views/Audit');
const Billing = () => import('@/views/Billing');
const Documents = () => import('@/views/childrens/management/Documents');
const Management = () => import('@/views/Management');
const Notifications = () => import('@/views/childrens/management/Notifications');
const TimelineAll = () => import('@/views/childrens/management/TimelineAll');
const Payments = () => import('@/views/childrens/management/Payments');
const Persons = () => import('@/views/Persons');
const Places = () => import('@/views/Places');
const FormRRPlagas = () => import('@/components/lodgings/FormRRPlagas');
const ShowCertificates = () => import('@/views/ShowCertificates');

export default [
	{
		path: '/audit',
		name: 'audit',
		component: Audit,
		meta: {
			title: 'Auditoria',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/persons',
		name: 'persons',
		component: Persons,
		meta: {
			title: 'Personas',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/:mes/resumen-certificados',
		name: 'resumen-certificados',
		component: ShowCertificates,
		meta: {
			title: 'Certificados',
			layout: 'simple',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
		props: route => {
			const { mes } = route.params;
			return { mes };
		},
	},
	{
		path: '/places',
		name: 'places',
		component: Places,
		meta: {
			title: 'Establecimientos',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/management',
		name: 'management',
		component: Management,
		meta: {
			title: 'Planificación',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
		children: [
			{
				path: 'activities',
				name: 'activities',
				component: Activities,
				meta: {
					title: 'Actividades',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'all-activities',
				name: 'all-activities',
				component: TimelineAll,
				meta: {
					title: 'Todas las actividades',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'notifications',
				name: 'notifications',
				component: Notifications,
				meta: {
					title: 'Notificaciones',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'payments',
				name: 'payments',
				component: Payments,
				meta: {
					title: 'Pagos',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'documents',
				name: 'documents',
				component: Documents,
				meta: {
					title: 'Documentos',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
			{
				path: 'assistance',
				name: 'panel-assistance',
				component: Assistance,
				meta: {
					title: 'Control de asistencia',
					layout: 'layout',
					requiresAuth: true,
					isAdmin: true,
					isSuperUser: true,
				},
			},
		],
	},
	{
		path: '/billing',
		name: 'billing',
		component: Billing,
		meta: {
			title: 'Facturación',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/account',
		name: 'account',
		component: Account,
		meta: {
			title: 'cuenta',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
	{
		path: '/rrplagas/certificate/:idLodging/work-order/:index/',
		name: 'form-rr-plagas',
		component: FormRRPlagas,
		meta: {
			title: 'RR Plagas',
			layout: 'layout',
			requiresAuth: true,
			isAdmin: true,
			isSuperUser: true,
		},
	},
];
